import React from "react";

import { Icon, IconWithBackground } from "shared/types";

import {
  IconWithBackgroundWrap,
  IconWrap,
} from "@components/UI/Icons/IconWrap";

const Check: React.FC<Icon> = ({ inlineSize, color }) => (
  <svg
    viewBox="0 0 15 11"
    version="1.1"
    width={undefined !== inlineSize ? inlineSize.width : "unset"}
    height={undefined !== inlineSize ? inlineSize.height : "unset"}
    fillRule="evenodd"
    strokeWidth="1"
  >
    <path
      d="M0.568745571,6.46539517 L3.1841847,9.07539418 L4.5443766,10.4321805 C5.27680859,11.1892732 6.5058878,11.1892732 7.26421523,10.4321805 L8.6249523,9.07539418 L14.4312544,3.28098433 C15.1895819,2.5244353 15.1895819,1.29786353 14.4312544,0.567411773 C13.6988224,-0.189137258 12.4700158,-0.189137258 11.7114158,0.567411773 L5.90484108,6.36100608 L3.28940195,3.75100707 C2.53107452,2.9936425 1.327073,2.9936425 0.568745571,3.75100707 C-0.189581857,4.50837164 -0.189581857,5.73385602 0.568745571,6.46539517"
      id="Fill-1"
      fill={color}
    />
  </svg>
);

const CheckIcon: React.FC<Icon> = (props) => {
  return <IconWrap IconComponent={Check} type="check" {...props} />;
};

const CheckIconRoundedBG: React.FC<IconWithBackground> = (props) => {
  return (
    <IconWithBackgroundWrap {...props} type="check">
      <IconWrap IconComponent={Check} type="check" {...props} />
    </IconWithBackgroundWrap>
  );
};

export default CheckIcon;

export { CheckIconRoundedBG };
